// extracted by mini-css-extract-plugin
module.exports = {"error":"InputPhone_error__Lpj7q","label":"InputPhone_label__o_SXM","container":"InputPhone_container__RiOkZ","invalid":"InputPhone_invalid__kyrf1"};